import { useEffect } from "react";

/** Re-runs `reload` whenever queued offline changes finish syncing,
 *  so temp records are replaced by their fresh server copies. */
export function useSyncedReload(reload) {
  useEffect(() => {
    const handler = () => reload();
    window.addEventListener("julia-synced", handler);
    return () => window.removeEventListener("julia-synced", handler);
  }, [reload]);
}
